import React, { useEffect, useState } from "react";
import WikiArticle from "../WikiArticle";
import { Link } from "react-router-dom";
import { Skeleton, Typography } from "antd";
import { getContentPerCategoryService } from "../wiki.api";
import { checkValue } from "../../../constant/helper";

const { Paragraph } = Typography;

const LegalVocabulary = (props) => {
  let {
    category: { title, description: text, id: where },
    headerClick = () => {},
    allowRequest = false,
  } = props;

  const [loading, setLoading] = useState(true);
  const [legalVocabulary, setLegalVocabulary] = useState({
    content: [],
  });

  useEffect(() => {
    let isMounted = true;
    if (allowRequest && checkValue(where)) {
      setLoading(true);
      getContentPerCategoryService({
        categoryId: where,
        pageNumber: 0,
        pageSize: 5,
        sort: "DESC",
        sortKey: "id",
        title: "",
      })
        .then((res) => {
          if (isMounted)
            if (res.hasOwnProperty("data")) {
              setLegalVocabulary(res.data);
            } else {
              setLegalVocabulary({ content: [] });
            }
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          if (isMounted) setLoading(false);
        });
    }
    return () => {
      isMounted = false;
    };
  }, [allowRequest, where]);

  return (
    <>
      <div className="legal-vocabulary" onClick={headerClick}   >
        <Skeleton
          active={true}
          loading={allowRequest && (loading || props.loading)}
        >
          <div className="header">
            <Paragraph ellipsis className="title" >
              {title}
            </Paragraph>
            <Paragraph ellipsis className="text">
              {text}
            </Paragraph>
          </div>
          {legalVocabulary.hasOwnProperty("content") &&
          legalVocabulary.content.length ? (
            <>
              <div className="word-wrapper">
                {legalVocabulary.content.map((content, i) => (
                  <WikiArticle
                    key={content.id}
                    Id={content.id}
                    Number={i + 1}
                    Title={content.title.fields[0]}
                    VisitCount={content.visitedCount}
                    Description={content.summary.fields[0]}
                  />
                ))}
              </div>
              <Link
                to={where ? `/wiki/category/${where}` : ""}
                className="click-for-more"
              >
                <p className="text">برای دیدن مطالب بیشتر کلیک کنید</p>
                <span className="icon-arrow-left-solid-green icon" />
              </Link>
            </>
          ) : (
            // "مطلبی وجود ندارد"
            ""
          )}
        </Skeleton>
      </div>
    </>
  );
};

export default LegalVocabulary;
